module.exports = __webpack_public_path__ + "static/media/delete.78ee2c05.svg";